export class MarkHelper {
    addMarkInHtml(html: string, phrase: string): string {
        if (phrase && phrase.length > 0) {
            const regex = new RegExp(`(?<=>)[^<]*?(${phrase})(?=[^>]*?<)`, "gi");
            return html.replace(regex, `<mark>$1</mark>`);
        } else {
            return html;
        }
    }

    addMarkInText(text: string, phrase: string): string {
        if (phrase && phrase.length > 0) {
            const regex = new RegExp(phrase, "gi");
            return text.replace(regex, (match: string) => `<mark>${match}</mark>`);
        } else {
            return text;
        }
    }
}